import { Address } from '@thirdweb-dev/sdk';
import { OLD_WEETH_TOKEN } from '@app/constants/tokens';

export function isOldWethPool(
  token0Address: Address | undefined,
  token1Address: Address | undefined
) {
  if (!token0Address || !token1Address) {
    return false;
  }

  return (
    token0Address.toLowerCase() === OLD_WEETH_TOKEN ||
    token1Address.toLowerCase() === OLD_WEETH_TOKEN
  );
}
